import { inject, Injectable } from '@angular/core';

import { UISocketDataMessage } from '../../shared/models/UISocket';
import { SocketAction, SocketActionHandler } from '../../shared/services/SocketActionHandler';
import { DeviceMS } from '../models/Device';
import { SiteId } from '../models/Site';
import { SiteDevicesStore } from '../site-devices.store';

interface UISocketDeviceCreated extends UISocketDataMessage {
    device: DeviceMS;
    siteId: SiteId;
}

@Injectable()
export class DeviceCreatedHandler implements SocketActionHandler {
    readonly action: SocketAction = 'deviceCreated';

    private readonly siteDevices = inject(SiteDevicesStore);

    handle(message: UISocketDeviceCreated): void {
        this.siteDevices.deviceCreated(message.siteId, message.device);
    }
}
